'use client';
export {
  Label,
  //
  Root,
} from './label';
export type { LabelProps } from './label';
